(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // refs
    this.header = null;
    this.headerSection = null;
    this.predictiveSearch = null;

    // state
    this.headerBounds = { top: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;

    // cached geometry (filled ONLY after user intent)
    this.headerGroupHeight = 0;
    this.headerHeight = 0;
    this.headerBottomAbs = 0;
    this.stickyType = 'disable';

    // raf
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._rafMeasure = 0;
    this._needsMeasure = false;

    // observers (created ONLY after start)
    this.resizeObserver = null;
    this.io = null;

    // flags
    this._started = false;

    // binds
    this._onScrollEvent = this._onScrollEvent.bind(this);
    this._flushScroll = this._flushScroll.bind(this);

    this._scheduleMeasure = this._scheduleMeasure.bind(this);
    this._flushMeasure = this._flushMeasure.bind(this);

    this._onSectionLoad = this._onSectionLoad.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    // wake handlers (NO layout reads)
    this._wake = this._wake.bind(this);
    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);

    this.handleScrollOnce = this.handleScrollOnce.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });

    this._syncTopMenuLinksOffset();
    requestAnimationFrame(() => this._syncTopMenuLinksOffset());
  }

  _syncTopMenuLinksOffset() {
    const topMenuLinks = document.querySelector('.shopify-section-top-menu-links');
    let height = 0;
    if (
      topMenuLinks &&
      window.getComputedStyle(topMenuLinks).display !== 'none' &&
      window.getComputedStyle(topMenuLinks).position === 'sticky'
    ) {
      height = Math.round(topMenuLinks.offsetHeight || 0);
    }
    document.documentElement.style.setProperty('--sticky-top-menu-links-height', `${height}px`);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    window.removeEventListener('scroll', this._onScrollEvent);

    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this.resizeObserver) {
      try { this.resizeObserver.disconnect(); } catch(e) {}
      this.resizeObserver = null;
    }

    if (this.io) {
      try { this.io.disconnect(); } catch(e) {}
      this.io = null;
    }

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    if (this._rafMeasure) cancelAnimationFrame(this._rafMeasure);
    this._rafScroll = 0;
    this._rafMeasure = 0;

    this._started = false;
  }

  _wakeOnScroll() { this._wake('scroll'); }
  _wakeOnPointer() { this._wake('pointer'); }
  _wakeOnKey() { this._wake('key'); }

  _wake(_reason) {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this._start();
  }

  _start() {
    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.stickyType = this.headerSection?.dataset?.stickyType || 'disable';

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    this.onScrollHandler = (this.stickyType === 'on_scroll')
      ? this._onScrollLogic.bind(this)
      : this._onAlwaysScrollLogic.bind(this);

    window.addEventListener('scroll', this._onScrollEvent, { passive: true });
    document.addEventListener('shopify:section:load', this._onSectionLoad);
    window.addEventListener('scroll', this.handleScrollOnce, { passive: true });

    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.currentScrollTop = this._pendingScrollTop;

    this._scheduleMeasure();

    if (this.stickyType !== 'disable') {
      this._createIntersectionObserver();
      this._createResizeObserver();
    }

    this.onScrollHandler();
  }


  _onScrollEvent() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._flushScroll);
  }

  _flushScroll() {
    this._rafScroll = 0;
    if (this.onScrollHandler) this.onScrollHandler();
  }

  _scheduleMeasure() {
    this._needsMeasure = true;
    if (this._rafMeasure) return;
    this._rafMeasure = requestAnimationFrame(this._flushMeasure);
  }

  _flushMeasure() {
    this._rafMeasure = 0;
    if (!this._needsMeasure) return;
    this._needsMeasure = false;
    this._setHeaderHeight();
  }

  _setHeaderHeight() {
    if (!this.header || !this.headerSection) return;

    const g1 = this.header.previousElementSibling;
    const g2 = g1 ? g1.previousElementSibling : null;
    const g3 = g2 ? g2.previousElementSibling : null;

    const inner = this.header.querySelector('.header') || this.headerSection;

    let total = inner ? inner.offsetHeight : 0;
    if (g1) total += g1.offsetHeight;
    if (g2) total += g2.offsetHeight;
    if (g3) total += g3.offsetHeight;

    this.headerGroupHeight = total;
    this.headerHeight = this.headerSection.offsetHeight || 0;

    const topMenuLinks =
      document.querySelector('.shopify-section-top-menu-links') ||
      (g1?.classList?.contains('shopify-section-top-menu-links') ? g1 : null);
    let topMenuLinksHeight = 0;
    if (
      topMenuLinks &&
      window.getComputedStyle(topMenuLinks).display !== 'none' &&
      window.getComputedStyle(topMenuLinks).position === 'sticky'
    ) {
      topMenuLinksHeight = Math.round(topMenuLinks.offsetHeight || 0);
    }

    document.documentElement.style.setProperty('--sticky-top-menu-links-height', `${topMenuLinksHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${this.headerGroupHeight}px`);
    document.documentElement.style.setProperty(
      '--sticky-header-height',
      this.stickyType === 'disable' ? '0px' : `${this.headerHeight + topMenuLinksHeight}px`
    );

    if (topMenuLinks && !this._topMenuLinksObserved && this.resizeObserver) {
      this.resizeObserver.observe(topMenuLinks);
      this._topMenuLinksObserved = true;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBottomAbs = rect.bottom + scrollTop;

    if (!this.headerBounds || typeof this.headerBounds.top !== 'number') {
      this.headerBounds = { top: rect.top + scrollTop };
    }
  }

  _onSectionLoad(event) {
    if (
      event?.target?.closest?.('.shopify-section-header') ||
      event?.target?.closest?.('.shopify-section-announcement-bar') ||
      event?.target?.closest?.('.shopify-section-top-menu-links')
    ) {
      this._scheduleMeasure();
      this._onScrollEvent();
    }
  }

  _createResizeObserver() {
    if (this.resizeObserver || !this.headerSection) return;
    this.resizeObserver = new ResizeObserver(() => {
      this._scheduleMeasure();
    });
    this.resizeObserver.observe(this.headerSection);

    const topMenuLinks = document.querySelector('.shopify-section-top-menu-links');
    if (topMenuLinks) this.resizeObserver.observe(topMenuLinks);
  }

  _createIntersectionObserver() {
    if (this.io || !this.headerSection) return;

    this.io = new IntersectionObserver((entries, observer) => {
      const e = entries && entries[0];
      if (e && e.intersectionRect) this.headerBounds = e.intersectionRect;
      else this.headerBounds = { top: 0 };
      observer.disconnect();
      this.io = null;
    });

    this.io.observe(this.headerSection);
  }

  handleScrollOnce() {
    const shopifySection = this.header;
    if (!shopifySection) {
      window.removeEventListener('scroll', this.handleScrollOnce);
      return;
    }

    const cls = shopifySection.className || '';
    const w = window.innerWidth;

    const overlapEnabled =
      cls.includes('overlap-enable') ||
      (cls.includes('overlap-desktop') && w > 1024) ||
      (cls.includes('overlap-mobile') && w < 1025);

    if (overlapEnabled) {
      const st = window.scrollY || document.documentElement.scrollTop || 0;
      if (st > 5) shopifySection.classList.add('animate');
    }

    window.removeEventListener('scroll', this.handleScrollOnce);
  }


  disableTransitionForMs(ms) {
    if (!this.header) return;
    this.header.classList.add('transition-none');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('transition-none');
    }, ms);
  }

  _onScrollLogic() {
    if (!this.header || !this.headerSection) return;

    if (document.body.classList.contains('disable-scroll') ||
        document.body.classList.contains('disable-scroll-body')) return;
    if (document.body.classList.contains('after-focusout')) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop <= 0) {
      this.reset();
      this.currentScrollTop = 0;
      return;
    }

    if (this.querySelector('details-dropdown[open]')) {
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.disableTransitionForMs(300);
      }

      if (scrollTop >= (this.headerBounds?.top || 0)) {
        this.header.classList.remove('shopify-section-header-sticky', 'animate', 'disable-visibility');
      }

      const delta = scrollTop - (this.currentScrollTop ?? 0);
      if (delta < 0) this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.currentScrollTop = scrollTop;
      return;
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const headerBottom = this.headerBottomAbs || (this.headerHeight ? (this.headerHeight + 1) : 0);

    if (scrollTop > this.currentScrollTop + 3 && scrollTop > (this.headerGroupHeight || 0)) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
      if (!this.preventReveal) {
        this.reveal();
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this.hide();
      }
    } else if (scrollTop <= (this.headerBounds?.top || 0)) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  _onAlwaysScrollLogic() {
    if (!this.header) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop > 5) this.header.classList.add('animate');
    if (
      scrollTop < 5 &&
      !document.body.classList.contains('disable-scroll') &&
      !document.body.classList.contains('disable-scroll-body') &&
      !document.body.classList.contains('after-focusout')
    ) {
      this.header.classList.remove('animate');
    }
  }

  hide() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'disable-visibility');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('disable-visibility');
    }, 100);
  }

  reveal() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden', 'disable-visibility');
  }

  reset() {
    if (!this.header) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
      'transition-none',
      'disable-visibility'
    );
  }
}

customElements.define('sticky-header', StickyHeader);

  class SearchElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        if(!this.querySelector('.search-field__text')) return
        this.querySelector('.search-field__text').addEventListener('focus', () => {
            const scrollY = window.scrollY || window.pageYOffset;
            document.body.dataset.scrollY = scrollY;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('disable-scroll-body')
        })
        this.querySelector('.search-field__text').addEventListener('focusout', () => {
            this.querySelector('.search-field__text').value = ''
            if (document.body.classList.contains('disable-scroll-body')) {
                document.body.classList.add('after-focusout')
                document.documentElement.style.scrollBehavior = 'auto'
                const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
                document.body.classList.remove('disable-scroll-body')
                document.body.style.top = '';
                window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
            }
            setTimeout(() => {document.documentElement.style.scrollBehavior = 'smooth'},10)
            setTimeout(() => document.body.classList.remove('after-focusout'), 200)
        })
    }

  }
  customElements.define('search-element', SearchElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbt-draft-full-price-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sbt-draft-products')) {
    customElements.define('sbt-draft-products', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-sbt-load-more]');
        if (!button || this.ready) return;
        this.ready = true;
        button.addEventListener('click', () => {
          const cards = Array.from(this.querySelectorAll('[data-sbt-product]'));
          const next = cards.filter(card => card.hidden).slice(0, Number(this.dataset.step) || 4);
          next.forEach(card => { card.hidden = false; });
          const shown = cards.filter(card => !card.hidden).length;
          this.querySelector('[data-sbt-product-status]').textContent = shown + ' of ' + cards.length + ' products shown';
          if (shown === cards.length) {
            next[0]?.querySelector('a')?.focus({ preventScroll: true });
            button.hidden = true;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbt-draft-logo-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbt-draft-logo-strip')) {
 customElements.define('sbt-draft-logo-strip',class extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.viewport=this.querySelector('[data-logo-viewport]');this.track=this.querySelector('[data-logo-track]');this.original=this.querySelector('[data-logo-original]');this.toggle=this.querySelector('[data-logo-toggle]');this.controls=this.querySelector('[data-logo-controls]');
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=false;this.hovered=false;this.focused=false;this.visible=false;this.few=this.original.children.length<3;
   this.toggleAttribute('data-logo-few',this.few);
   this.updateButtons=()=>{};
   this.update=()=>{
    const interactive=this.paused||this.hovered||this.focused||this.reduced.matches||this.few;
    this.toggleAttribute('data-logo-motion',!interactive);
    this.toggleAttribute('data-logo-running',!interactive&&this.visible&&!document.hidden);
    this.toggle.textContent=this.paused?'Play logos':'Pause logos';this.toggle.setAttribute('aria-pressed',String(this.paused));
    this.toggle.hidden=this.reduced.matches||this.few;
    this.controls.hidden=this.few&&this.original.scrollWidth<=this.viewport.clientWidth;
    this.updateButtons();
   };
   this.resize=()=>{
    this.track.querySelectorAll('[data-logo-copy]').forEach(x=>x.remove());
    const period=this.original.getBoundingClientRect().width;
    if(period&&!this.few){
     this.style.setProperty('--logo-period',period+'px');this.style.setProperty('--logo-duration',Math.max(24,period/24)+'s');
     const copies=Math.min(10,Math.ceil(this.viewport.clientWidth/period)+1);
     for(let i=0;i<copies;i++){const copy=this.original.cloneNode(true);copy.removeAttribute('data-logo-original');copy.setAttribute('data-logo-copy','');copy.setAttribute('aria-hidden','true');copy.inert=true;copy.querySelectorAll('a').forEach(a=>a.setAttribute('tabindex','-1'));this.track.append(copy);}
    }this.update();
   };
   this.addEventListener('pointerenter',()=>{this.hovered=true;this.update();},opts);
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.update();},opts);
   this.addEventListener('focusin',event=>{this.focused=true;this.update();if(event.target.closest('[data-logo-original]'))requestAnimationFrame(()=>event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));},opts);
   this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.update();});},opts);
   this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.update();},opts);
   this.viewport.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){this.paused=true;this.update();}},{...opts,passive:true});
   document.addEventListener('visibilitychange',this.update,opts);this.reduced.addEventListener('change',this.update,opts);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});this.observer.observe(this);
   this.resizeObserver=new ResizeObserver(this.resize);this.resizeObserver.observe(this.viewport);this.resize();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.controller=null;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbt-storefront-brand-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbt-draft-logo-strip')) {
 customElements.define('sbt-draft-logo-strip',class extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.viewport=this.querySelector('[data-logo-viewport]');this.track=this.querySelector('[data-logo-track]');this.original=this.querySelector('[data-logo-original]');this.toggle=this.querySelector('[data-logo-toggle]');this.controls=this.querySelector('[data-logo-controls]');
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=false;this.hovered=false;this.focused=false;this.visible=false;this.few=this.original.children.length<3;
   this.toggleAttribute('data-logo-few',this.few);
   this.updateButtons=()=>{};
   this.update=()=>{
    const interactive=this.paused||this.hovered||this.focused||this.reduced.matches||this.few;
    this.toggleAttribute('data-logo-motion',!interactive);
    this.toggleAttribute('data-logo-running',!interactive&&this.visible&&!document.hidden);
    this.toggle.textContent=this.paused?'Play logos':'Pause logos';this.toggle.setAttribute('aria-pressed',String(this.paused));
    this.toggle.hidden=this.reduced.matches||this.few;
    this.controls.hidden=this.few&&this.original.scrollWidth<=this.viewport.clientWidth;
    this.updateButtons();
   };
   this.resize=()=>{
    this.track.querySelectorAll('[data-logo-copy]').forEach(x=>x.remove());
    const period=this.original.getBoundingClientRect().width;
    if(period&&!this.few){
     this.style.setProperty('--logo-period',period+'px');this.style.setProperty('--logo-duration',Math.max(24,period/24)+'s');
     const copies=Math.min(10,Math.max(1,Math.ceil(this.viewport.clientWidth/period)));
     for(let i=0;i<copies;i++){const copy=this.original.cloneNode(true);copy.removeAttribute('data-logo-original');copy.setAttribute('data-logo-copy','');copy.setAttribute('aria-hidden','true');copy.inert=true;copy.querySelectorAll('a').forEach(a=>a.setAttribute('tabindex','-1'));this.track.append(copy);}
    }this.update();
   };
   this.addEventListener('pointerenter',()=>{this.hovered=true;this.update();},opts);
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.update();},opts);
   this.addEventListener('focusin',event=>{this.focused=true;this.update();if(event.target.closest('[data-logo-original]'))requestAnimationFrame(()=>event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));},opts);
   this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.update();});},opts);
   this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.update();},opts);
   this.viewport.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){this.paused=true;this.update();}},{...opts,passive:true});
   document.addEventListener('visibilitychange',this.update,opts);this.reduced.addEventListener('change',this.update,opts);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});this.observer.observe(this);
   this.resizeObserver=new ResizeObserver(this.resize);this.resizeObserver.observe(this.viewport);this.resize();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.controller=null;}
 });
}

  } catch(e) { console.error(e); }
})();
})();
